import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@bingads-webui-react/primitive';

export const BulkMMAConvertEditorFooter = ({
  i18n,
  showSave,
  onSave,
  onClose,
}) => (
  <div className="ad-edit-action-buttons" style={{ marginTop: 20, marginBottom: 20 }}>
    {showSave &&
      <Button
        btnStyle="primary"
        className="save-mma-bulk-conversion-button"
        onClick={onSave}
      >
        {i18n.getString('Audience_Campaign_Ad_Save')}
      </Button>
      }
    <Button
      btnStyle="default"
      className="cancel-mma-bulk-conversion-button"
      onClick={onClose}
    >
      {i18n.getString('Audience_Campaign_Cancel_Label')}
    </Button>
  </div>
);

BulkMMAConvertEditorFooter.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  showSave: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
